import React, { useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import { VerificationBannerBox } from "./VerificatonBannerBox";
import { trackEvent } from "src/Amplitude";

interface VerificationBannerProps {
  open: boolean;
  onClose?: () => void;
  message: string;
  title?: string;
}

export function VerificationBanner(props: VerificationBannerProps) {
  useEffect(() => {
    if (props.open) {
      if (props.message.includes("Account Reports"))
        trackEvent("Guest Viewed Verification Banner", { variant: "Transaction Reports" });
      if (props.message.includes("alerts"))
        trackEvent("Guest Viewed Verification Banner", { variant: "Price Alerts" });
      if (props.message.includes("Fiat to Crypto"))
        trackEvent("Guest Viewed Verification Banner", { variant: "Wallets Page" });
    }
  }, []);

  return (
    <Dialog
      {...props}
      disableEnforceFocus
      PaperProps={{
        style: { borderRadius: 10 },
      }}>
      <VerificationBannerBox
        message={props.message}
        onClose={props.onClose}
        hideHeader={false}
        buttonTitle={"Verify Account Now"}
        subTitle={props.title ?? "Verify your account to access this feature"}
        subTitleFontSize={"18px"}
        messageFontSize={"14px"}
        iconHeight={"208"}
        iconWidth={"180"}
        boxWidth={"410px"}
        boxHeight={"495px"}
      />
    </Dialog>
  );
}
